import { Pipe, PipeTransform } from '@angular/core';
import { dateFormatter } from '../utils';

@Pipe({ name: 'aztDate' })
export class AztDatePipe implements PipeTransform {
  transform(value: Date | string): unknown {
    value = new Date(value);

    return dateFormatter(value);
  }
}
